export enum DefinitionLevelEntityType {
System,
User,
}
